<template>
  <el-dialog
    :visible.sync="visible"
    :show-close="true"
    custom-class="service-dialog"
    width="580px"
    @close="handleClose"
  >
    <div class="dialog-header">
      <div class="dialog-top">
        <img :src="require('@/assets/logo-active.png')" :alt="getText('productDialog.logoAlt', '亚科Logo')" class="dialog-logo">
        <div class="dialog-title">
          {{ getText('productDialog.hotline', '免费服务热线：') }}<span> {{currentLanguage !=='zh'?'+86-15062454963':'13451648594'}} </span>
        </div>
      </div>
      <div class="dialog-bottom">
        {{ getText('productDialog.description', '请留下您的需求信息，我们将在1个工作日内与您联系') }}
      </div>
    </div>

    <el-form
      ref="serviceForm"
      :model="formData"
      :rules="rules"
      label-position="left"
      class="service-form"
      :label-width="currentLanguage==='en'?'160px':'80px'"
    >
      <el-form-item :label="getText('productDialog.form.name', '姓名')" prop="name">
        <el-input 
          v-model="formData.name"
          :placeholder="getText('productDialog.form.namePlaceholder', '请输入您的姓名')"
        />
      </el-form-item>

      <el-form-item :label="getText('productDialog.form.contact', '联系方式')" prop="contact">
        <el-input 
          v-model="formData.contact"
          :placeholder="getText('productDialog.form.contactPlaceholder', '请输入您的电话/手机号/邮箱')"
        />
      </el-form-item>

      <el-form-item :label="getText('productDialog.form.company', '公司名称')" prop="company">
        <el-input 
          v-model="formData.company"
          :placeholder="getText('productDialog.form.companyPlaceholder', '请输入您的公司名称')"
        />
      </el-form-item>

      <el-form-item :label="getText('productDialog.form.product', '产品名称')" prop="product">
        <el-input 
          v-model="formData.product"
          :placeholder="getText('productDialog.form.productPlaceholder', '请输入产品名称')"
        />
      </el-form-item>

      <el-form-item :label="getText('productDialog.form.cas', 'CAS号')" prop="cas">
        <el-input
            v-model="formData.cas"
            :placeholder="getText('productDialog.form.casPlaceholder', '请输入CAS号')"
        />
      </el-form-item>

      <el-form-item :label="getText('productDialog.form.requirement', '采购需求')" prop="requirement">
        <el-input 
          v-model="formData.requirement"
          type="textarea"
          :rows="4"
          :placeholder="getText('productDialog.form.requirementPlaceholder', '请输入您的采购需求')"
        />
      </el-form-item>

      <el-form-item class="form-footer">
        <el-button type="primary" @click="handleSubmit">{{ getText('productDialog.form.submit', '提交') }}</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { submitProductForm } from '@/api'
import {mapState} from "vuex";

export default {
  name: 'ProductDialog',
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  watch: {
    // 监听语言变化
    currentLanguage: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          // 强制重新渲染组件以更新文本
          this.$forceUpdate()
        }
      },
      immediate: false
    },
    item: {
      handler(newVal) {
        if (newVal && newVal.casNo) {
          // 设置 CAS 号默认值
          this.formData.cas = newVal.casNo
          // 如果有产品名称也可以设置
          if (newVal.name) {
            this.formData.product = newVal.name
          }
          this.formData.belongs = newVal.belongs
        }
      },
      immediate: true // 组件创建时立即执行一次
    }
  },
  data() {
    return {
      visible: false,
      formData: {
        name: '',
        contact: '',
        company: '',
        product: '',
        cas: '',
        requirement: '',
        type: 1,
        belongs: 1
      }
    }
  },

  computed: {
    rules() {
      return {
        name: [
          { required: true, message: this.getText('productDialog.validation.nameRequired', '请输入姓名'), trigger: 'blur' }
        ],
        contact: [
          { required: true, message: this.getText('productDialog.validation.contactRequired', '请输入联系方式'), trigger: 'blur' }
        ],
        cas: [
          { required: true, message: this.getText('productDialog.validation.casRequired', '请输入CAS号'), trigger: 'blur' }
        ]
      }
    },
    ...mapState({
      currentLanguage: state => state?.app?.language || 'zh' 
    })
  },

  methods: {
    // 安全的文本获取方法
    getText(key, fallback) {
      try {
        // 尝试使用 i18n
        if (this.$i18n && this.$i18n.t) {
          return this.$i18n.t(key)
        }
        // 如果 i18n 不可用，返回默认值
        return fallback
      } catch (error) {
        console.warn(`Translation failed for key: ${key}`, error)
        return fallback
      }
    },

    // 打开弹窗
    show() {
      this.visible = true
    },

    // 关闭弹窗
    handleClose() {
      this.visible = false
      this.$refs.serviceForm.resetFields()
    },

    // 提交表单方法
    async handleSubmit() {
      console.log(this.formData,'-------')
      try {
        // 先进行表单验证
        const valid = await this.$refs.serviceForm.validate()
          .catch(error => {
            console.error('表单验证失败:', error)
            return false
          })

        if (!valid) {
          return
        }

        // 显示加载状态
        this.$loading.show()

        try {
          // 调用 API 提交表单
          const response = await submitProductForm(this.formData)
          
          if (response.success) {
            this.$message.success(this.getText('productDialog.messages.submitSuccess', '提交成功'))
            this.handleClose()
          } else {
            this.$message.error(response.msg || this.getText('productDialog.messages.submitFailed', '提交失败'))
          }
        } finally {
          // 关闭加载状态
          this.$loading.hide()
        }
      } catch (error) {
        console.error('提交表单失败:', error)
        this.$message.error(this.getText('productDialog.messages.submitFailedRetry', '提交失败，请稍后重试'))
      }
    }
  }
}
</script>

<style lang="less" scoped>

@import '../assets/styles/variables.less';
::v-deep .el-dialog__body {
  padding: 0 50px 30px  !important;
}
.service-dialog {
  :deep(.el-dialog__header) {
    display: none;
  }
  .dialog-header {
    padding: 0 10px;
    .dialog-top {
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      .dialog-logo {
        width: 100px;
        height: auto;
      }

      .dialog-title {
        font-size: 14px;
        color: #333;
        margin: 0;
        font-weight: normal;
        display: flex;
        align-items: flex-end;
        position: relative;
      }
      .dialog-title::before{
        content: ' ';
        display: block;
        width: 0;
        height: 0;
        border-color: transparent #82B436 transparent transparent;
        border-style: solid;
        border-width: 9px 9px 0 0;
        position: absolute;
        left: -15px;
        bottom: 5px;
      }
    }

    .dialog-bottom {
      font-size: 18px;
      color: #414141;
      line-height: 17px;
      text-align: center;
      font-style: normal;
    }

  }

  .service-form {
    padding: 30px;

    :deep(.el-form-item) {
      margin-bottom: 20px;

      .el-form-item__label {
        line-height: 1.4;
        padding-bottom: 8px;
        color: #333;
      }

      .el-input__inner {
        height: 40px;
        line-height: 40px;
      }

      .el-textarea__inner {
        padding: 10px;
      }
    }

    .form-footer {
      margin-bottom: 0;
      margin-top: 30px;
      text-align: center;
      ::v-deep .el-form-item__content{
        margin-left: auto !important;
      }
      .el-button {
        width: 80%;
        height: 40px;
        background: #325177;
        border-color: #325177;
        font-size: 16px;
        &:hover {
          background: lighten(#1E2F60, 10%);
          border-color: lighten(#1E2F60, 10%);
        }
      }
    }
  }
}

// 全局样式覆盖
:deep(.el-dialog__headerbtn) {
  z-index: 10;
  .el-dialog__close {
    color: #999;
    font-size: @font-size-note;
  }
}
</style> 